import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
import { Autocomplete } from "../Autocomplete";
import { FIELDS_TYPE_FORMS, FORM_FIELDS_PERSON } from "../../utils/constants";
import { useStyles } from "./styles";
import {
  Close,
  ContentCopyOutlined,
  DeleteOutlineRounded,
} from "@mui/icons-material";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Fields } from "../../types/forms";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import { useCallback } from "react";
import Button from "@mui/material/Button";
import { map } from "lodash";
import Checkbox from "@mui/material/Checkbox";

type FieldFormProps = {
  isAddClients: boolean;
  isCustumer_Likes?: boolean;
  disableButtonRemove: boolean;
  data: Fields;
  error?: any;
  onDuplicate?: () => void;
  onRemove?: () => void;
  onChange?: (key: string, value: any) => void;
  onFieldSon?: (
    indexOptionSelectFieldFather: number,
    optionSelectFieldFather: string) => void;
  onDeleteOption?: (idOption: number) => void;
  onUpdatedQuestAnsw?: (id?) => void;
};

export function FieldForm({
  isAddClients = false,
  isCustumer_Likes = false,
  disableButtonRemove,
  data,
  error,
  onDuplicate,
  onRemove,
  onChange,
  onFieldSon,
  onDeleteOption,
  onUpdatedQuestAnsw
}: FieldFormProps) {
  const styles = useStyles();

  const handleAddOption = useCallback(() => {
    if (onChange) {
      onChange("optionSelect", [...data.optionSelect, undefined]);
    }
  }, [data.optionSelect, onChange]);

  const handleDeleteOption = useCallback(
    (id: number) => {
      if (onChange) {
        const tempOptions = data.optionSelect?.filter((opt) => Boolean(opt));
        tempOptions.splice(id, 1);
        onChange("optionSelect", tempOptions);
      }
    },
    [data.optionSelect, onChange]
  );

  const handleChangeValueOption = useCallback(
    (id: number, value: string) => {
      if (onChange) {
        const tempOptions = data.optionSelect;
        tempOptions[id] = value;

        onChange("optionSelect", tempOptions);
      }
    },
    [data.optionSelect, onChange]
  );

  const RenderOptions = useCallback(
    (item: { id: number; option: string }) => {
      return (
        <div key={item.id.toString()} className={styles.inputOptions}>
          {data.inputType?.value === "checkbox" ? (
            <Checkbox disabled readOnly />
          ) : (
            <Typography variant="body2" marginRight={1}>
              {item.id}.
            </Typography>
          )}

          <TextField
            autoFocus
            onKeyDown={({ key }) =>
              key === "Enter" ? handleAddOption() : () => { }
            }
            onChange={({ target: { value } }) =>
              handleChangeValueOption(item.id - 1, value)
            }
            value={item.option}
            fullWidth
            size="small"
            variant="standard"
            onBlur={() => { onUpdatedQuestAnsw && onUpdatedQuestAnsw(item.id - 1); }}
          />
          {item.id !== 1 && (
            <Tooltip title="Excluir" placement="bottom">
              <IconButton
                onClick={() => {
                  handleDeleteOption(item.id - 1);
                  onDeleteOption && onDeleteOption(item.id - 1);
                }}
              >
                <Close />
              </IconButton>
            </Tooltip>
          )}
          {(isCustumer_Likes && (data.inputType?.value === 'select')) && (
            <Button
              size="small"
              style={{ fontSize: '10px', left: '4px' }}
              onClick={() => { onFieldSon(item.id - 1, item.option) }}>
              Adicionar pergunta para essa resposta.
            </Button>
          )
          }
        </div>

      );
    },
    [
      isCustumer_Likes,
      data.inputType?.value,
      styles.inputOptions,
      handleAddOption,
      handleDeleteOption,
      handleChangeValueOption,
      onFieldSon,
      onDeleteOption,
      onUpdatedQuestAnsw
    ]
  );

  return (
    <Paper elevation={0} className={styles.root}>
      {(data.isFieldSon && isCustumer_Likes) ? (
        <div className={styles.headerSon}>
          <p>{data.fieldFather.labelFather}</p>
          <p style={{ position: 'relative', left: '10px' }}>{data.fieldFather.optionSelectFieldFather}</p>
        </div>
      ) : (<></>)
      }
      <div className={styles.rootHeader}>
        <TextField
          disabled={data.disabled}
          className={styles.inputQuestion}
          size="small"
          fullWidth
          label="Pergunta"
          value={data.label}
          onChange={
            onChange
              ? ({ target: { value } }) => onChange("label", value)
              : undefined
          }
          onBlur={() => { onUpdatedQuestAnsw && onUpdatedQuestAnsw() }}
          helperText={error?.label}
          error={Boolean(error?.label)}
        />

        <Autocomplete
          disabled={data.disabled}
          className={styles.inputQuestion}
          size="small"
          fullWidth
          options={FIELDS_TYPE_FORMS}
          getOptionLabel={(option) => option.label}
          value={data.inputType}
          onChange={
            onChange ? (_, value) => onChange("inputType", value) : () => { }
          }
        />

        {isAddClients && (
          <Autocomplete
            disabled={data.disabled}
            size="small"
            fullWidth
            options={FORM_FIELDS_PERSON}
            getOptionLabel={(option) => option.label}
            value={data.key}
            defaultValue={data.key}
            onChange={
              onChange ? (_, value) => onChange("key", value) : () => { }
            }
            helperText={error?.key?.value}
            error={Boolean(error?.key?.value)}
          />
        )}
      </div>
      {data.optionSelect && (
        <div className={styles.rootContent}>
          {map(data.optionSelect, (option, index) =>
            RenderOptions({ id: index + 1, option })
          )}
          <div className={styles.btnAddOption}>
            <Button size="small" onClick={handleAddOption}>
              Adicionar opção
            </Button>
          </div>
        </div>
      )}

      <div className={styles.rootFooter}>
        <div className={styles.contentBtnActionsFooter}>
          <Tooltip title="Duplicar" placement="bottom">
            <IconButton disabled={data.disabled} onClick={onDuplicate}>
              <ContentCopyOutlined />
            </IconButton>
          </Tooltip>
          {!disableButtonRemove && (
            <Tooltip title="Excluir" placement="bottom">
              <IconButton disabled={data.disabled} onClick={onRemove}>
                <DeleteOutlineRounded />
              </IconButton>
            </Tooltip>
          )}
        </div>

        <div>
          <FormControlLabel
            disabled={data.disabled}
            onChange={
              onChange ? (_, value) => onChange("required", value) : undefined
            }
            checked={Boolean(data.required)}
            control={<Switch inputProps={{ "aria-label": "controlled" }} />}
            label="Obrigatório"
          />
          <FormControlLabel
            disabled={data.disabled}
            onChange={
              onChange ? (_, value) => onChange("active", value) : undefined
            }
            checked={Boolean(data.active)}
            control={
              <Switch readOnly inputProps={{ "aria-label": "controlled" }} />
            }
            label="Ativo"
          />
        </div>
      </div>
    </Paper>
  );
}
